import { render } from "./ResourceTableHeader.vue?vue&type=template&id=926b2450"
import script from "./ResourceTableHeader.vue?vue&type=script&lang=js"
export * from "./ResourceTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableHeader.vue"]])

export default __exports__